import React, { useEffect, useState, useRef } from 'react'
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { READ_GBC1, READ_GBC2, READ_NEWGBC1, READ_NEWGBC2 } from '../../config/api';
import { Rightdefault, Rightexpanded, Leftdefault, Leftexpanded, Bgmusic } from './components'
import { Checkdevice, Loading } from '../../components'
import { GB_LOADING_TIME, STARTUP_NAME } from '../../config/constants';
import axios from 'axios'
import './Guestbookv1cast.css'

const midcss = { width: '100vw', height: '100vh', overflow: 'hidden', fontFamily: 'Lato', display: 'flex', placeContent: 'center', backgroundColor: 'white', alignItems: 'center', textAlign: 'center' }

const SECS = [5000, 6000, 7000, 8000, 9000, 10000] // [0] 5 second to next image
const IMG_DURATION = 5000 // init state 5 second to next image

const GALLERY_QUOTA = 2000

// 2 minutes * 60 seconds * 1000 milliseconds = 300000ms
// 60 min / 3 min = 20 apis call /hr 
const API_CALL_DURATION = 2 * 60 * 1000
// const API_CALL_DURATION = 1000

const MSG_DURATION = 5000
// const MSG_DURATION = 500

const castno_urls_map = {
    'cast1': [READ_GBC1, READ_NEWGBC1],
    'cast2': [READ_GBC2, READ_NEWGBC2],
}

// user need to first name photo in sequence  001, 002, 003, ..., 499, 500
// click sort, to sort them in order
// can be img or mp4 file

function Guestbookv1cast(props) {

    const handle = useFullScreenHandle();
    const [validity, setValidity] = useState(-1)
    const [firsttime, setFirsttime] = useState(true)
    const [apisignal, setApisignal] = useState(false)
    const [signalcounter, setSignalcounter] = useState(0) // eslint-disable-line

    // for both
    const [expandstate, setExpandstate] = useState(1) // 0: loading, 1: default state, 2: expand state

    // for left [ slide portion ]
    const [selectindex, setSelectindex] = useState(-1)
    const [musicindex, setMusicindex] = useState(0)
    const [medias, setMedias] = useState([]) // [ { content, mtype, fn }, { content, mtype, fn } ]
    const [musicgate, setMusicgate] = useState(false) // open music modal
    const [musicobjs, setMusicobjs] = useState([]) // [blobdata, blobdata]
    const [leftduration, setLeftduration] = useState(IMG_DURATION) // seconds that will switch to next image
    const mediaRef = useRef(null)

    // for right [ messenger portion ]
    const [msgs, setMsgs] = useState([]) // [ { id, txt, time, img, css }, { id, txt, time, img, css} ]
    const [newmsgs, setNewmsgs] = useState([])
    const [startindex, setStartindex] = useState(0)
    const [casttype, setCasttype] = useState(0)
    const [msgtype, setMsgtype] = useState(0)
    const [msgframetype, setMsgframetype] = useState(0) // determine by casttype, some casttype do not hav msg function
    const [images, setImages] = useState(['', '', ''])
    const [modrmvmsgs, setModrmvmsgs] = useState([]) // msgs rmv by mod

    const device = Checkdevice()
    
    useEffect(()=>{
        console.log('casttype updated ', casttype)
    },[casttype])

    useEffect(() => {
        const { urlhandler, castno, passcode, gbid } = props.match.params
        if (firsttime) {
            props.hidetopbar(true)
            if (device === 'MOBILE') {
                setValidity(-2)
            }
            else {
                axios({
                    method: 'POST',
                    url: castno_urls_map[castno][0],
                    data: { urlhandler, passcode, gbid }
                }).then((item) => {
                    const { status, data } = item
                    const { msgs, casttype, msgtype, msgframetype, images, galleryimgs } = data.gb
                    if (status === 200) {
                        setTimeout(() => setValidity(2), GB_LOADING_TIME);
                        setMsgs(msgs)
                        setApisignal(true)
                        setCasttype(casttype)
                        setMsgtype(msgtype)
                        setMsgframetype(msgframetype)
                        setImages(images)

                        // assemble medias
                        for (let i = 0; i < galleryimgs.length; i++) {
                            medias.push({ content: galleryimgs[i], mtype: 0, fn: galleryimgs[i], key: 'imgimg_' + galleryimgs[i] })
                        }

                        var newInfo = setInterval(() => {
                            let options = {
                                method: 'POST',
                                url: castno_urls_map[castno][1],
                                data: castno === 'cast1' ? { activeone: item.data.activeone, urlhandler, passcode, gbid } : { activetwo: item.data.activetwo, urlhandler, passcode, gbid }
                            }
                            axios(options).then((i_item) => {
                                const { status, data } = i_item
                                if (status === 200) {
                                    setSignalcounter(0)
                                    setApisignal(true)
                                    setCasttype((ct)=>{
                                        if(ct !==data.gb.casttype){
                                            return data.gb.casttype
                                        }
                                        return ct
                                    })
                                    setMsgtype((mt)=>{
                                        if(mt!==data.gb.msgtype){
                                            return data.gb.msgtype
                                        }
                                        return mt
                                    })

                                    let newmsgs_temp = castno === 'cast1' ? data.gb.newmsgs1.slice() : data.gb.newmsgs2.slice()
                                    const { modrmvmsgs } = data.gb

                                    if (modrmvmsgs && modrmvmsgs.length > 0) { // remove all mod removed imgs from newmsgs and msgs
                                        for (let i = 0; i < modrmvmsgs.length; i++) { // for newmsgs
                                            const curr_id = modrmvmsgs[i].id
                                            for (let j = 0; j < newmsgs_temp.length; j++) {
                                                if (newmsgs_temp[j]['id'] === curr_id) {
                                                    newmsgs_temp.splice(j, 1)
                                                }
                                            }
                                        }
                                    }

                                    setNewmsgs([...newmsgs, ...newmsgs_temp])
                                    setMsgs((old_msgs) => {
                                        let msgs_temp = old_msgs.slice()
                                        if (modrmvmsgs && modrmvmsgs.length > 0) { // remove all mod removed imgs from newmsgs and msgs
                                            for (let i = 0; i < modrmvmsgs.length; i++) { // for msgs
                                                const curr_id = modrmvmsgs[i].id
                                                for (let j = 0; j < msgs_temp.length; j++) {
                                                    if (msgs_temp[j]['id'] === curr_id) {
                                                        msgs_temp.splice(j, 1)
                                                    }
                                                }
                                            }
                                        }
                                        return [...msgs_temp, ...newmsgs_temp]
                                    })
                                    setModrmvmsgs(modrmvmsgs)
                                }
                            }).catch((e) => {
                                setApisignal(false)
                                setSignalcounter((count) => {
                                    if (count === 2) {
                                        setTimeout(() => setValidity(1), GB_LOADING_TIME);
                                        clearInterval(newInfo);
                                    }
                                    return count + 1
                                })
                            })
                        }, API_CALL_DURATION)

                    }
                }).catch(() => {
                    setTimeout(() => setValidity(0), GB_LOADING_TIME);
                })
            }
            setFirsttime(true)
        }
    }, [])

    useEffect(()=>{
        if(!firsttime){
            if(expandstate===0){
                setExpandstate(1)
            }
        }
    })


    const onChange = (state, handle) => {
        if (state) {
            setExpandstate(0)
            setMusicgate(false)
            setMusicindex(0)
            setTimeout(() => { setExpandstate(2) }, [GB_LOADING_TIME])
        }
        else {
            setExpandstate(0)
            setSelectindex(-1)
            setMusicindex(0)
            setTimeout(() => { setExpandstate(1) }, [GB_LOADING_TIME])
        }
    }

    function sortByKey(array, key) {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }

    const updateMedia = (e) => {
        if (medias.length < GALLERY_QUOTA) {
            let mediaraw = []
            for (let i = 0; i < e.target.files.length; i++) {
                const file = e.target.files[i]
                const fn = file.name.split('.')[0]
                if (file.type.includes("image")) {
                    const img = document.createElement("img");
                    img.src = URL.createObjectURL(file);
                    img.onload = function () {
                        mediaraw.push({ content: img.src, mtype: 0, fn: fn, key: 'imgimg_' + i })
                        setMedias([...medias, ...mediaraw])
                    }
                }
                else if (file.type.includes("video")) {
                    mediaraw.push({ content: { file: file, blobData: URL.createObjectURL(file) }, mtype: 1, fn: fn, key: 'vidvid_' + i })
                    setMedias([...medias, ...mediaraw])
                }
            }
            e.target.value = null; // users can reupload similar file
        }
        else {
            alert('You have reach max GALLERY_QUOTA')
        }
    }


    if (validity === -2) return <div style={midcss}>Device not supported.</div>
    else if (validity === -1) return <Loading /> 
    else if (validity === 0) return <div style={midcss}>Invalid URL.</div>
    else if (validity === 1) return <div style={midcss}>Unable to connect to your Guestbook. Please ensure only single Guestbook is active everytime.</div>
    else if (validity === 2) {
        return (
            <div className="gbcast_root">
                {expandstate === 0
                    ? <div style={midcss}>Connecting to {`${STARTUP_NAME}`} Guestbook Cast.</div>
                    : expandstate === 1
                        ? [
                            <div key="gbcastsignal" className={"gbcastsignal" + apisignal ? 'on' : 'off'} />,
                            <svg key='gbcastsvgbtn' className="gbcastexpandsvg" onClick={() => handle.enter()} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1927"><path d="M853.333333 213.333333a42.666667 42.666667 0 0 0-42.666666-42.666666h-213.333334a42.666667 42.666667 0 0 0 0 85.333333h109.653334l-139.946667 140.373333a42.666667 42.666667 0 0 0 0 60.586667 42.666667 42.666667 0 0 0 60.586667 0L768 316.586667V426.666667a42.666667 42.666667 0 0 0 42.666667 42.666666 42.666667 42.666667 0 0 0 42.666666-42.666666zM456.96 567.04a42.666667 42.666667 0 0 0-60.586667 0L256 706.986667V597.333333a42.666667 42.666667 0 0 0-42.666667-42.666666 42.666667 42.666667 0 0 0-42.666666 42.666666v213.333334a42.666667 42.666667 0 0 0 42.666666 42.666666h213.333334a42.666667 42.666667 0 0 0 0-85.333333H316.586667l140.373333-140.373333a42.666667 42.666667 0 0 0 0-60.586667z" p-id="1928"></path></svg>,
                            <div key="gbcastwhitestrip" style={{ display: 'flex', flexDirection: 'row', width: '100vw', height: 45, position: 'absolute', backgroundColor: 'white', zIndex: 2, borderBottom: 'thin solid #70707038' }} >
                                <div className="gbcastdom_root">
                                    <div style={{ cursor: 'pointer', position: 'relative', }} onClick={() => mediaRef.current.click()}>
                                        <input
                                            ref={mediaRef}
                                            accept="image/*,video/*"
                                            className="gbcastinputmedia"
                                            id="formControlsFile"
                                            type='file'
                                            multiple="multiple"
                                            name="input-file"
                                            onChange={(e) => updateMedia(e)}
                                        />
                                        <svg style={{ position: 'absolute', zIndex: 3, cursor: 'pointer', width: 35, height: 35, margin: 5, padding: 3, left: 0, verticalAlign: 'middle', fill: '#707070', overflow: 'hidden', display: 'flex', backgroundColor: 'white', borderRadius: 5, border: 'thin solid #707070' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8442"><path d="M725.333333 768a85.333333 85.333333 0 0 0 85.333334-85.333333V298.666667a85.333333 85.333333 0 0 0-85.333334-85.333334h-195.84a42.666667 42.666667 0 0 1-29.866666-12.373333l-60.586667-60.586667a42.666667 42.666667 0 0 0-29.866667-12.373333H128a85.333333 85.333333 0 0 0-85.333333 85.333333v469.333334a85.333333 85.333333 0 0 0 85.333333 85.333333zM320 256A64 64 0 1 1 256 320 64 64 0 0 1 320 256z m405.333333 405.333333a21.333333 21.333333 0 0 1-21.333333 21.333334h-554.666667a21.333333 21.333333 0 0 1-21.333333-21.333334v-14.506666a19.626667 19.626667 0 0 1 4.693333-12.8L256 477.44a22.186667 22.186667 0 0 1 14.933333-8.106667 21.333333 21.333333 0 0 1 16.64 7.68l61.866667 74.666667a20.906667 20.906667 0 0 0 16.213333 7.68 21.76 21.76 0 0 0 17.066667-8.533333l122.88-158.72a21.76 21.76 0 0 1 34.133333 0l181.333334 241.92a21.76 21.76 0 0 1 4.266666 12.8zM896 384v384a85.333333 85.333333 0 0 1-85.333333 85.333333H213.333333a85.333333 85.333333 0 0 0 85.333334 85.333334h512a170.666667 170.666667 0 0 0 170.666666-170.666667v-298.666667a85.333333 85.333333 0 0 0-85.333333-85.333333z" p-id="8443"></path></svg>
                                    </div>
                                    <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { setMedias(sortByKey(medias.slice(), 'fn').slice()) }}>
                                        <svg style={{ zIndex: 3, cursor: 'pointer', width: 35, height: 35, margin: 5, padding: 3, left: 40, verticalAlign: 'middle', fill: '#707070', overflow: 'hidden', position: 'absolute', display: 'flex', backgroundColor: 'white', borderRadius: 5, border: 'thin solid #707070' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7666"><path d="M842.312695 750.299426q0-35.986237-25.161109-66.267339t-58.87992-30.281102q-29.69596 0-47.396507 21.138257t-17.700547 53.686784 20.845686 54.271926 59.68449 21.723399q28.598818 0 48.566791-15.433122t19.967973-38.838804zM493.714311 822.857042q0 6.875419-5.705135 13.677696l-182.271753 182.271753q-5.705135 5.119993-13.165696 5.119993-6.875419 0-13.165696-5.119993l-182.856895-182.856895q-8.557703-9.142845-4.022852-19.967973 4.534851-11.41027 17.115405-11.41027l109.714137 0 0-786.284647q0-7.972561 5.119993-13.165696t13.165696-5.119993l109.714137 0q7.972561 0 13.165696 5.119993t5.119993 13.165696l0 786.284647 109.714137 0q7.972561 0 13.165696 5.119993t5.119993 13.165696zM922.257729 783.433095q0 35.401095-7.460561 69.412477t-23.405683 65.170197-38.838804 54.564497-56.319924 37.449092-72.850187 13.970267q-35.401095 0-61.732488-9.142845-13.677696-4.534851-23.990825-8.557703l22.308541-64.585055q8.557703 4.022852 17.700547 6.290277 21.138257 7.460561 42.861656 7.460561 47.981649 0 76.873039-33.42624t38.034234-83.163316l-1.170284 0q-11.995412 13.165696-35.108524 21.138257t-48.27422 7.972561q-60.562204 0-98.889009-40.886802t-38.253662-98.596438q0-59.977061 41.179373-101.741576t103.42386-41.691372q70.29019 0 117.174698 53.979355t46.884508 144.310661zM905.142324 373.687366l0 65.170197-267.995065 0 0-65.170197 95.451299 0 0-246.856808q0-4.022852 0.292571-10.825128t0.292571-9.727987l0-9.142845-1.170284 0-4.022852 6.875419q-4.534851 7.460561-14.84798 17.700547l-35.401095 33.133669-46.884508-49.151933 109.714137-105.691285 70.29019 0 0 373.68635 94.281015 0z" p-id="7667"></path></svg>
                                    </div>
                                    <div className="gbcast_secroot">
                                        {SECS.map((s, i) => {
                                            return <div
                                                className={leftduration === s ? "gbcast_secselected" : "gbcast_sec"}
                                                key={s + '_' + i}
                                                onClick={() => setLeftduration(s)}
                                            >
                                                {s / 1000 + 's'}
                                            </div>
                                        })}
                                    </div>
                                    <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setMusicgate(true)}>
                                        <svg style={{ zIndex: 3, cursor: 'pointer', width: 35, height: 35, margin: 5, padding: 3, left: 303, verticalAlign: 'middle', fill: '#707070', overflow: 'hidden', position: 'absolute', display: 'flex', backgroundColor: 'white', borderRadius: 5, border: 'thin solid #707070' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1643"><path d="M950.857143 128V768c0 80.566857-120.576 109.714286-182.857143 109.714286s-182.857143-29.147429-182.857143-109.714286 120.576-109.714286 182.857143-109.714286c37.705143 0 75.446857 6.838857 109.714286 22.272v-306.870857l-438.857143 135.424v405.138286c0 80.566857-120.576 109.714286-182.857143 109.714286s-182.857143-29.147429-182.857143-109.714286 120.576-109.714286 182.857143-109.714286c37.705143 0 75.446857 6.838857 109.714286 22.272V274.249143c0-23.990857 16.018286-45.129143 38.838857-52.553143l475.428571-146.285714c5.156571-1.718857 10.276571-2.304 16.018286-2.304a54.857143 54.857143 0 0 1 54.857143 54.857143z" fill="" p-id="1644"></path></svg>
                                    </div>
                                </div>
                            </div>,
                            <Leftdefault
                                key={'leftdefaultroot'}
                                medias={medias}
                            />,
                            <Rightdefault
                                key={'rightdefaultroot'}
                                msgs={msgs}
                                newmsgs={newmsgs}
                                emptynew={() => setNewmsgs([])}
                                updatestart={(i) => setStartindex(i)}
                                startindex={startindex}
                                msgtype={msgtype}
                                modrmvmsgs={modrmvmsgs}
                            />,
                        ] : null}

                <FullScreen handle={handle} onChange={onChange}>
                    {expandstate === 2
                        ? <div className="full-screenable-node" style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%' }}>
                            <Leftexpanded
                                key={'le' + casttype}
                                casttype={casttype}
                                medias={medias}
                                selectindex={selectindex} updateSelectindex={(i) => setSelectindex(i)}
                                duration={leftduration} updateDuration={(d) => setLeftduration(d)}
                                musicobjs={musicobjs}
                                musicindex={musicindex} updateMusicindex={() => setMusicindex((i) => { return (i + 1 >= musicobjs.length) ? 0 : i + 1 })}
                            />
                            <Rightexpanded
                                key={'re' + casttype}
                                casttype={casttype}
                                msgtype={msgtype}
                                msgs={msgs}
                                newmsgs={newmsgs}
                                emptynew={() => setNewmsgs([])}
                                updatestart={(i) => setStartindex(i)}
                                startindex={startindex}
                                msgduration={MSG_DURATION}
                                msgframetype={msgframetype}
                                images={images}
                                modrmvmsgs={modrmvmsgs}
                            />
                        </div>
                        : null}
                </FullScreen>
                <Bgmusic
                    musicgate={musicgate}
                    onMusicdone={() => setMusicgate(false)}
                    musicobjs={musicobjs} updateMusicobjs={(objs) => setMusicobjs(objs)}
                />
            </div>
        )
    }
    else {
        return <div style={midcss}>Connecting to Guestbook Cast.</div>
    }
}

export default Guestbookv1cast